export default __webpack_public_path__ + "static/media/info.60d43811.svg";